import SelectableProceduresGroupedList from './SelectableProceduresGroupedList';

export default SelectableProceduresGroupedList;
